import {ValueObject} from '@s-ui/domain'

import {InvalidParamsSharedError} from '../../shared/Errors/InvalidParamsSharedError.js'
import {RequestSearchValueObject} from '../ValueObjects/RequestSearchValueObject.js'

export class GetAIFaqsForUrlSearchRequest extends ValueObject {
  #filters
  #pageType

  constructor({filters, pageType}) {
    super()
    this.#filters = filters
    this.#pageType = pageType
  }

  static validate({pageType, search}) {
    if (!pageType) {
      throw InvalidParamsSharedError.create('[GetAIFaqsForUrlSearchRequest.validate] pageType is required')
    }

    if (!search) {
      throw InvalidParamsSharedError.create('[GetAIFaqsForUrlSearchRequest.validate] search is required')
    }
  }

  static createFromSearch({config, listingSectionId, pageType, search}) {
    GetAIFaqsForUrlSearchRequest.validate({pageType, search})

    const {filters} = RequestSearchValueObject.createToApi({config, listingSectionId, search}).getSearchFromFilters()

    return new GetAIFaqsForUrlSearchRequest({filters, pageType})
  }

  get value() {
    return {
      pageType: this.#pageType,
      filters: this.#filters
    }
  }
}
